import { PrimaryButton } from "@digipost/dds-buttons-react";
import { Heading } from "@digipost/dds-heading-react";
import { FC } from "react";
import { useSearchParams } from "react-router";

import Translated from "../infrastructure/Translated";
import { useTranslate } from "../infrastructure/useTranslate";
import mannMedNettbrett from "./mann_med_nettbrett.svg";
import styles from "./RegistrationCompleted.module.css";

export const RegistrationCompleted: FC = () => {
  const translate = useTranslate();
  const [searchParams] = useSearchParams();
  const senderId = searchParams.get("senderId");

  return (
    <div className={styles.wrapper}>
      <Heading level={1} size="large">
        <Translated textKey={"register.org.completed.title"} />
      </Heading>
      <div className={styles.contentWrapper}>
        <p>
          <Translated textKey="register.org.completed.text" />
        </p>
        <img
          className={styles.illustration}
          src={mannMedNettbrett}
          alt={translate("confirm.man_with_tablet")}
        />
        <PrimaryButton
          as="a"
          href={`/virksomhetsadmin/?onboarding=true&senderId=${senderId}`}
        >
          <Translated textKey={"register.org.completed.button"} />
        </PrimaryButton>
      </div>
    </div>
  );
};
